import * as React from 'react';
import { ClearFormButton, Form, CustomSubmitButton, Select } from "soprasteria-ui-library";
import { OrthodonticLkgCfPatientExtensionSearchApi } from '../../../api/OrthodonticLkgCfPatientExtensionSearchApi';
import { IOrthodonticLkgCfPatientExtensionSearchParams } from '../../../models/IOrthodonticLkgCfPatientExtension';
import { IListItem } from 'soprasteria-ui-library/dist/models/IFormInput';
import { useAuth } from '../../../App';

interface IOrthodonticLkgCfPatientExtensionSearchForm {
    searchOrthodonticLkgCfPatientExtensions: (data: IOrthodonticLkgCfPatientExtensionSearchParams) => void;
    preSetSearchParams?: IOrthodonticLkgCfPatientExtensionSearchParams;
}

export const OrthodonticLkgCfPatientExtensionSearchForm: React.FunctionComponent<IOrthodonticLkgCfPatientExtensionSearchForm> = ({ searchOrthodonticLkgCfPatientExtensions, preSetSearchParams }) => {

    const auth = useAuth();
    const api = new OrthodonticLkgCfPatientExtensionSearchApi(auth);
    const [statuses, setStatuses] = React.useState<IListItem[]>();

    React.useEffect(() => {
        getStatuses();
    }, [])

    const getStatuses = () => {
        api.getOrthodonticLkgCfPatientExtensionStatuses((data) => {
            const newStatuses = data.map<IListItem>((status) => { return { text: status.description, value: status.orthodonticLkgCfPatientExtensionStatusId.toString() } });
            setStatuses(newStatuses);
        });
    }

    return (
        <section>
            <Form onSubmit={searchOrthodonticLkgCfPatientExtensions}>
                <div className="row">
                    <div className="col-6">
                        <Select name="orthodonticLkgCfPatientExtensionStatusId" label="Status"
                            selectedValue={preSetSearchParams?.orthodonticLkgCfPatientExtensionStatusId ? preSetSearchParams.orthodonticLkgCfPatientExtensionStatusId.toString() : undefined}
                            inlineLabel options={statuses ?? []} isClearable placeholder="Välj status"/>
                    </div>
                    <div className="col-12">
                        <div className="text-right panel">
                            <ClearFormButton />
                            <CustomSubmitButton>Sök</CustomSubmitButton>
                        </div>
                    </div>
                </div>
            </Form>
        </section>
    )
}